var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.01001H3C1.9 3.01001 1 3.91001 1 5.01001V9.00001H3V4.99001H21V19.02H3V15H1V19.01C1 20.11 1.9 20.99 3 20.99H21C22.1 20.99 23 20.11 23 19.01V5.01001C23 3.90001 22.1 3.01001 21 3.01001Z",
    fill: "#3F46AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16L15 12L11 8V11H1V13H11V16Z",
    fill: "#3F46AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.727aae4c6279c773b8b674aec24403ed.svg";
export { ForwardRef as ReactComponent };